module.exports = `<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8"/><title>Leetcode - Valid Parentheses</title><style>
/* cspell:disable-file */
/* webkit printing magic: print all background colors */
html {
	-webkit-print-color-adjust: exact;
}
* {
	box-sizing: border-box;
	-webkit-print-color-adjust: exact;
}

html,
body {
	margin: 0;
	padding: 0;
}
@media only screen {
	body {
		margin: 2em auto;
		max-width: 900px;
		color: rgb(55, 53, 47);
	}
}

body {
	line-height: 1.5;
	white-space: pre-wrap;
}

a,
a.visited {
	color: inherit;
	text-decoration: underline;
}

.pdf-relative-link-path {
	font-size: 80%;
	color: #444;
}

h1,
h2,
h3 {
	letter-spacing: -0.01em;
	line-height: 1.2;
	font-weight: 600;
	margin-bottom: 0;
}

.page-title {
	font-size: 2.5rem;
	font-weight: 700;
	margin-top: 0;
	margin-bottom: 0.75em;
}

h1 {
	font-size: 1.875rem;
	margin-top: 1.875rem;
}

h2 {
	font-size: 1.5rem;
	margin-top: 1.5rem;
}

h3 {
	font-size: 1.25rem;
	margin-top: 1.25rem;
}

.source {
	border: 1px solid #ddd;
	border-radius: 3px;
	padding: 1.5em;
	word-break: break-all;
}

.callout {
	border-radius: 3px;
	padding: 1rem;
}

figure {
	margin: 1.25em 0;
	page-break-inside: avoid;
}

figcaption {
	opacity: 0.5;
	font-size: 85%;
	margin-top: 0.5em;
}

mark {
	background-color: transparent;
}

.indented {
	padding-left: 1.5em;
}

hr {
	background: transparent;
	display: block;
	width: 100%;
	height: 1px;
	visibility: visible;
	border: none;
	border-bottom: 1px solid rgba(55, 53, 47, 0.09);
}

img {
	max-width: 100%;
}

@media only print {
	img {
		max-height: 100vh;
		object-fit: contain;
	}
}

@page {
	margin: 1in;
}

.collection-content {
	font-size: 0.875rem;
}

.column-list {
	display: flex;
	justify-content: space-between;
}

.column {
	padding: 0 1em;
}

.column:first-child {
	padding-left: 0;
}

.column:last-child {
	padding-right: 0;
}

.table_of_contents-item {
	display: block;
	font-size: 0.875rem;
	line-height: 1.3;
	padding: 0.125rem;
}

.table_of_contents-indent-1 {
	margin-left: 1.5rem;
}

.table_of_contents-indent-2 {
	margin-left: 3rem;
}

.table_of_contents-indent-3 {
	margin-left: 4.5rem;
}

.table_of_contents-link {
	text-decoration: none;
	opacity: 0.7;
	border-bottom: 1px solid rgba(55, 53, 47, 0.18);
}

table,
th,
td {
	border: 1px solid rgba(55, 53, 47, 0.09);
	border-collapse: collapse;
}

table {
	border-left: none;
	border-right: none;
}

th,
td {
	font-weight: normal;
	padding: 0.25em 0.5em;
	line-height: 1.5;
	min-height: 1.5em;
	text-align: left;
}

th {
	color: rgba(55, 53, 47, 0.6);
}

ol,
ul {
	margin: 0;
	margin-block-start: 0.6em;
	margin-block-end: 0.6em;
}

li > ol:first-child,
li > ul:first-child {
	margin-block-start: 0.6em;
}

ul > li {
	list-style: disc;
}

ul.to-do-list {
	padding-inline-start: 0;
}

ul.to-do-list > li {
	list-style: none;
}

.to-do-children-checked {
	text-decoration: line-through;
	opacity: 0.375;
}

ul.toggle > li {
	list-style: none;
}

ul {
	padding-inline-start: 1.7em;
}

ul > li {
	padding-left: 0.1em;
}

ol {
	padding-inline-start: 1.6em;
}

ol > li {
	padding-left: 0.2em;
}

.mono ol {
	padding-inline-start: 2em;
}

.mono ol > li {
	text-indent: -0.4em;
}

.toggle {
	padding-inline-start: 0em;
	list-style-type: none;
}

/* Indent toggle children */
.toggle > li > details {
	padding-left: 1.7em;
}

.toggle > li > details > summary {
	margin-left: -1.1em;
}

.selected-value {
	display: inline-block;
	padding: 0 0.5em;
	background: rgba(206, 205, 202, 0.5);
	border-radius: 3px;
	margin-right: 0.5em;
	margin-top: 0.3em;
	margin-bottom: 0.3em;
	white-space: nowrap;
}

.collection-title {
	display: inline-block;
	margin-right: 1em;
}

.page-description {
	margin-bottom: 2em;
}

.simple-table {
	margin-top: 1em;
	font-size: 0.875rem;
	empty-cells: show;
}
.simple-table td {
	height: 29px;
	min-width: 120px;
}

.simple-table th {
	height: 29px;
	min-width: 120px;
}

.simple-table-header-color {
	background: rgb(247, 246, 243);
	color: black;
}
.simple-table-header {
	font-weight: 500;
}

time {
	opacity: 0.5;
}

.icon {
	display: inline-block;
	max-width: 1.2em;
	max-height: 1.2em;
	text-decoration: none;
	vertical-align: text-bottom;
	margin-right: 0.5em;
}

img.icon {
	border-radius: 3px;
}

.user-icon {
	width: 1.5em;
	height: 1.5em;
	border-radius: 100%;
	margin-right: 0.5rem;
}

.user-icon-inner {
	font-size: 0.8em;
}

.text-icon {
	border: 1px solid #000;
	text-align: center;
}

.page-cover-image {
	display: block;
	object-fit: cover;
	width: 100%;
	max-height: 30vh;
}

.page-header-icon {
	font-size: 3rem;
	margin-bottom: 1rem;
}

.page-header-icon-with-cover {
	margin-top: -0.72em;
	margin-left: 0.07em;
}

.page-header-icon img {
	border-radius: 3px;
}

.link-to-page {
	margin: 1em 0;
	padding: 0;
	border: none;
	font-weight: 500;
}

p > .user {
	opacity: 0.5;
}

td > .user,
td > time {
	white-space: nowrap;
}

input[type="checkbox"] {
	transform: scale(1.5);
	margin-right: 0.6em;
	vertical-align: middle;
}

p {
	margin-top: 0.5em;
	margin-bottom: 0.5em;
}

.image {
	border: none;
	margin: 1.5em 0;
	padding: 0;
	border-radius: 0;
	text-align: center;
}

.code,
code {
	background: rgba(135, 131, 120, 0.15);
	border-radius: 3px;
	padding: 0.2em 0.4em;
	border-radius: 3px;
	font-size: 85%;
	tab-size: 2;
}

code {
	color: #eb5757;
}

.code {
	padding: 1.5em 1em;
}

.code-wrap {
	white-space: pre-wrap;
	word-break: break-all;
}

.code > code {
	background: none;
	padding: 0;
	font-size: 100%;
	color: inherit;
}

blockquote {
	font-size: 1.25em;
	margin: 1em 0;
	padding-left: 1em;
	border-left: 3px solid rgb(55, 53, 47);
}

.bookmark {
	text-decoration: none;
	max-height: 8em;
	padding: 0;
	display: flex;
	width: 100%;
	align-items: stretch;
}

.bookmark-title {
	font-size: 0.85em;
	overflow: hidden;
	text-overflow: ellipsis;
	height: 1.75em;
	white-space: nowrap;
}

.bookmark-text {
	display: flex;
	flex-direction: column;
}

.bookmark-info {
	flex: 4 1 180px;
	padding: 12px 14px 14px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.bookmark-image {
	width: 33%;
	flex: 1 1 180px;
	display: block;
	position: relative;
	object-fit: cover;
	border-radius: 1px;
}

.bookmark-description {
	color: rgba(55, 53, 47, 0.6);
	font-size: 0.75em;
	overflow: hidden;
	max-height: 4.5em;
	word-break: break-word;
}

.bookmark-href {
	font-size: 0.75em;
	margin-top: 0.25em;
}

.sans { font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"; }
.code { font-family: "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace; }
.serif { font-family: Lyon-Text, Georgia, ui-serif, serif; }
.mono { font-family: iawriter-mono, Nitti, Menlo, Courier, monospace; }
.pdf .sans { font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK JP'; }
.pdf:lang(zh-CN) .sans { font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK SC'; }
.pdf:lang(zh-TW) .sans { font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK TC'; }
.pdf:lang(ko-KR) .sans { font-family: Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol", 'Twemoji', 'Noto Color Emoji', 'Noto Sans CJK KR'; }
.pdf .code { font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK JP'; }
.pdf:lang(zh-CN) .code { font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC'; }
.pdf:lang(zh-TW) .code { font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK TC'; }
.pdf:lang(ko-KR) .code { font-family: Source Code Pro, "SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK KR'; }
.pdf .serif { font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Serif CJK JP'; }
.pdf:lang(zh-CN) .serif { font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Serif CJK SC'; }
.pdf:lang(zh-TW) .serif { font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Serif CJK TC'; }
.pdf:lang(ko-KR) .serif { font-family: PT Serif, Lyon-Text, Georgia, ui-serif, serif, 'Twemoji', 'Noto Color Emoji', 'Noto Serif CJK KR'; }
.pdf .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK JP'; }
.pdf:lang(zh-CN) .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK SC'; }
.pdf:lang(zh-TW) .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK TC'; }
.pdf:lang(ko-KR) .mono { font-family: PT Mono, iawriter-mono, Nitti, Menlo, Courier, monospace, 'Twemoji', 'Noto Color Emoji', 'Noto Sans Mono CJK KR'; }
.highlight-default {
	color: rgba(55, 53, 47, 1);
}
.highlight-gray {
	color: rgba(120, 119, 116, 1);
	fill: rgba(120, 119, 116, 1);
}
.highlight-brown {
	color: rgba(159, 107, 83, 1);
	fill: rgba(159, 107, 83, 1);
}
.highlight-orange {
	color: rgba(217, 115, 13, 1);
	fill: rgba(217, 115, 13, 1);
}
.highlight-yellow {
	color: rgba(203, 145, 47, 1);
	fill: rgba(203, 145, 47, 1);
}
.highlight-teal {
	color: rgba(68, 131, 97, 1);
	fill: rgba(68, 131, 97, 1);
}
.highlight-blue {
	color: rgba(51, 126, 169, 1);
	fill: rgba(51, 126, 169, 1);
}
.highlight-purple {
	color: rgba(144, 101, 176, 1);
	fill: rgba(144, 101, 176, 1);
}
.highlight-pink {
	color: rgba(193, 76, 138, 1);
	fill: rgba(193, 76, 138, 1);
}
.highlight-red {
	color: rgba(212, 76, 71, 1);
	fill: rgba(212, 76, 71, 1);
}
.highlight-default_background {
	color: rgba(55, 53, 47, 1);
}
.highlight-gray_background {
	background: rgba(241, 241, 239, 1);
}
.highlight-brown_background {
	background: rgba(244, 238, 238, 1);
}
.highlight-orange_background {
	background: rgba(251, 236, 221, 1);
}
.highlight-yellow_background {
	background: rgba(251, 243, 219, 1);
}
.highlight-teal_background {
	background: rgba(237, 243, 236, 1);
}
.highlight-blue_background {
	background: rgba(231, 243, 248, 1);
}
.highlight-purple_background {
	background: rgba(244, 240, 247, 0.8);
}
.highlight-pink_background {
	background: rgba(249, 238, 243, 0.8);
}
.highlight-red_background {
	background: rgba(253, 235, 236, 1);
}
.block-color-default {
	color: inherit;
	fill: inherit;
}
.block-color-gray {
	color: rgba(120, 119, 116, 1);
	fill: rgba(120, 119, 116, 1);
}
.block-color-brown {
	color: rgba(159, 107, 83, 1);
	fill: rgba(159, 107, 83, 1);
}
.block-color-orange {
	color: rgba(217, 115, 13, 1);
	fill: rgba(217, 115, 13, 1);
}
.block-color-yellow {
	color: rgba(203, 145, 47, 1);
	fill: rgba(203, 145, 47, 1);
}
.block-color-teal {
	color: rgba(68, 131, 97, 1);
	fill: rgba(68, 131, 97, 1);
}
.block-color-blue {
	color: rgba(51, 126, 169, 1);
	fill: rgba(51, 126, 169, 1);
}
.block-color-purple {
	color: rgba(144, 101, 176, 1);
	fill: rgba(144, 101, 176, 1);
}
.block-color-pink {
	color: rgba(193, 76, 138, 1);
	fill: rgba(193, 76, 138, 1);
}
.block-color-red {
	color: rgba(212, 76, 71, 1);
	fill: rgba(212, 76, 71, 1);
}
.block-color-default_background {
	color: inherit;
	fill: inherit;
}
.block-color-gray_background {
	background: rgba(241, 241, 239, 1);
}
.block-color-brown_background {
	background: rgba(244, 238, 238, 1);
}
.block-color-orange_background {
	background: rgba(251, 236, 221, 1);
}
.block-color-yellow_background {
	background: rgba(251, 243, 219, 1);
}
.block-color-teal_background {
	background: rgba(237, 243, 236, 1);
}
.block-color-blue_background {
	background: rgba(231, 243, 248, 1);
}
.block-color-purple_background {
	background: rgba(244, 240, 247, 0.8);
}
.block-color-pink_background {
	background: rgba(249, 238, 243, 0.8);
}
.block-color-red_background {
	background: rgba(253, 235, 236, 1);
}
.select-value-color-uiBlue { background-color: rgba(35, 131, 226, .07); }
.select-value-color-pink { background-color: rgba(245, 224, 233, 1); }
.select-value-color-purple { background-color: rgba(232, 222, 238, 1); }
.select-value-color-green { background-color: rgba(219, 237, 219, 1); }
.select-value-color-gray { background-color: rgba(227, 226, 224, 1); }
.select-value-color-transparentGray { background-color: rgba(227, 226, 224, 0); }
.select-value-color-translucentGray { background-color: rgba(0, 0, 0, 0.06); }
.select-value-color-orange { background-color: rgba(250, 222, 201, 1); }
.select-value-color-brown { background-color: rgba(238, 224, 218, 1); }
.select-value-color-red { background-color: rgba(255, 226, 221, 1); }
.select-value-color-yellow { background-color: rgba(253, 236, 200, 1); }
.select-value-color-blue { background-color: rgba(211, 229, 239, 1); }
.select-value-color-pageGlass { background-color: undefined; }
.select-value-color-washGlass { background-color: undefined; }

.checkbox {
	display: inline-flex;
	vertical-align: text-bottom;
	width: 16;
	height: 16;
	background-size: 16px;
	margin-left: 2px;
	margin-right: 5px;
}

.checkbox-on {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%2358A9D7%22%2F%3E%0A%3Cpath%20d%3D%22M6.71429%2012.2852L14%204.9995L12.7143%203.71436L6.71429%209.71378L3.28571%206.2831L2%207.57092L6.71429%2012.2852Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E");
}

.checkbox-off {
	background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Crect%20x%3D%220.75%22%20y%3D%220.75%22%20width%3D%2214.5%22%20height%3D%2214.5%22%20fill%3D%22white%22%20stroke%3D%22%2336352F%22%20stroke-width%3D%221.5%22%2F%3E%0A%3C%2Fsvg%3E");
}

</style></head><body><article id="f44b104f-80e0-45af-931c-c34705b0d988" class="page sans"><header><h1 class="page-title">Leetcode - Valid Parentheses</h1><p class="page-description"></p></header><div class="page-body"><h3 id="a91651b8-4623-4c75-9843-692054bbe768" class="">Leetcode Prompt</h3><p id="72ea6f6d-16ea-4169-bfd2-faf91f7d1f4f" class=""><a href="https://leetcode.com/problems/valid-parentheses/">https://leetcode.com/problems/valid-parentheses/</a></p><hr id="076068ec-356e-44fa-85ac-67f8fe146f81"/><h3 id="0afd66cd-3151-46af-aa24-54722e125a86" class="">Prompt</h3><p id="6e75a9c8-02c8-4a9d-b18b-8e8db23929c3" class="">Given a string with bracket characters, we must determine if the string is valid</p><div id="cf667eb6-e59f-4e2c-99cf-34e9f8523c09" class="column-list"><div id="3547e46a-8301-4e2b-9e82-42c23c3be0fa" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="a7e6f782-8c03-476f-bf31-55148434ab8c" class="code"><code class="language-Python">class Solution:
	def isValid(self, s: str) -&gt; bool:</code></pre></div><div id="c5b50590-5770-4bdb-99d6-e6f603560c11" style="width:100%" class="column"><p id="ec4556d8-d388-4eb6-9acf-f468e58202cb" class="">We begin with the Solution class with the <code>isValid</code> function we will need to implement.</p><p id="d5db86c8-10db-4df3-86de-7ab2b385184c" class="">
</p></div></div><figure class="callout" style="white-space:pre-wrap;display:flex" id="1238494a-4ffc-493d-be08-62b18bbdb4c0"><div style="font-size:1.5em"><span class="icon">💡</span></div><div style="width:100%">Before any implementation should be done, we should<br/>1. Ask the interviewer clarifying questions for the problem. i.e:<br/>  - Input constraints<br/>  - Return values for edge cases<br/>  - Memory constraint<br/>2. Explain your approach to the problem (it does not have to be the most optimized approach)<br/></div></figure><p id="684b89b5-0f1d-4550-b092-421c905b8ced" class="">
</p><h3 id="d012f0ba-cdec-4416-8157-3d954ce60d71" class="">Questions</h3><ol type="1" id="4ee8fc59-d002-4a46-b62c-9716691aba03" class="numbered-list" start="1"><li>Can there be any characters in the string other than the expected brackets?<ul id="52ff8ed5-d5ea-4906-acc8-a9e3ef01e040" class="bulleted-list"><li style="list-style-type:disc">Clarifies the constraint of input value</li></ul></li></ol><ol type="1" id="44aba0b1-9c7e-4444-85a9-02b17ddfbd35" class="numbered-list" start="2"><li>What should be returned in the input string is empty?<ul id="cfe50e38-e4c0-4d61-92ff-df0e7bef3793" class="bulleted-list"><li style="list-style-type:disc">Clarifies the return value for an edge case where the input is an empty string</li></ul></li></ol><ol type="1" id="3145dab8-95c9-492d-86a2-a2a3c1f0c503" class="numbered-list" start="3"><li>Are there any memory constraint to the problem?<ul id="14700ae8-94dc-42da-966e-148cf55d3424" class="bulleted-list"><li style="list-style-type:disc">Clarifies the big-O space complexity of the problem</li></ul><ul id="9eafd597-09c1-423e-9411-257a9963cc9b" class="bulleted-list"><li style="list-style-type:disc">Most of the time, the interviewer will tell us this is not priority for the first iteration but should always align on expectation of solution with interviewer </li></ul></li></ol><p id="d3e16451-bd5e-47a4-8cf7-bc0214dea75a" class="">
</p><h3 id="f9fb3df7-a5a9-4428-a771-75099b898752" class="">Approach</h3><p id="77066f93-82b8-45b9-a34e-7aa95553da60" class="">Looking at the examples, we can see open/close brackets of the same type are adjacent. However, we should also considered nested brackets such as</p><details open=""><summary style="font-weight:600;font-size:1.25em;line-height:1.3;margin:0">Example</summary><div class="indented"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="ec762c67-969a-428d-a6fb-423378a98fc9" class="code"><code class="language-Plain Text">( { [ ] } ( { } ) )</code></pre></div></details><p id="ae84394c-425a-4beb-8e53-ee9c81852ae1" class="">In the case of nested brackets, we need a way to store the order of open brackets that we have seen so far while traversing the string and make sure there is a respective closing bracket in the expected order.</p><p id="fb7b5fa1-bb6d-4501-ad39-ed102d6bf779" class="">GIven the example above, the order of open brackets we will see before the first closing bracket is</p><details open=""><summary style="font-weight:600;font-size:1.25em;line-height:1.3;margin:0">Example</summary><div class="indented"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="cb56b3ac-6dff-40d0-b2ec-0c23c2cb1c7f" class="code"><code class="language-Plain Text">( { [
] &lt;- is a closing bracket</code></pre></div></details><p id="a8f06986-eb7a-476d-a6f8-8e0d4198ae9b" class="">The order of closing brackets we expect to see to be a valid string is</p><details open=""><summary style="font-weight:600;font-size:1.25em;line-height:1.3;margin:0">Example</summary><div class="indented"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="13af0c1c-fc33-4977-8120-2155da4a6293" class="code"><code class="language-Plain Text">Reminder: Order of open brackets:
( { [

Order of closing brackets to be valid:
] } )</code></pre></div></details><p id="42b52b1b-4cd7-49ae-888a-6af8701bb3c2" class="">We can see that with the most recent open bracket we saw, <code>]</code> is  expected to be the first closing bracket to see and <code>)</code> is the last closing bracket to see.</p><p id="400c1b80-c262-4ac4-896b-9ffe41781b0e" class="">This pattern is also known as Last-In-First-Out (LIFO) or the Stack data structure.</p><p id="777b515c-8ea5-4284-aade-4294afaf740d" class="">
</p><p id="fab250cd-50e6-4d78-9992-67e214de06eb" class="">Now that we have identified the data structure we intend to use, we now need to think about how we plan to integrate the stack data structure to solve this problem. </p><h3 id="d2b45659-4da8-4d5c-8c65-b4725aefea1a" class="">Pseudo Approach</h3><ol type="1" id="0e1969f9-9ad9-43f3-8fbd-e28b38326d46" class="numbered-list" start="1"><li>Instantiate an empty stack</li></ol><ol type="1" id="7fded1fe-024f-401c-a69c-ea22e3dbea28" class="numbered-list" start="2"><li>We will need to iterate each character in the string. For each character,<ol type="a" id="e298df58-f84b-44f9-9c42-33d89704d328" class="numbered-list" start="1"><li>If the character is an open bracket<ol type="i" id="be45e234-3135-485c-b015-80c56a0b66ba" class="numbered-list" start="1"><li>Push the character to the top of the stack</li></ol></li></ol><ol type="a" id="69fefe6d-0343-493d-8be6-296a93cce3bf" class="numbered-list" start="2"><li>If the character is a closing bracket, we will need to check if there is a corresponding open bracket of the same type in the correct order<ol type="i" id="1d10158b-6236-4417-a068-e16720c3039a" class="numbered-list" start="1"><li>Pop a character from the top of the stack (this is the open bracket)<ol type="1" id="f951a017-dc10-49e8-bdab-6e933e6f9cbd" class="numbered-list" start="1"><li>If there is nothing to pop, that means we saw a closing bracket without a corresponding open bracket (doesn’t have to be the same type)<ol type="a" id="0e8896a5-5250-4c62-a5c2-eb878815c499" class="numbered-list" start="1"><li>Return <code>False</code> immediately as the string is not a valid parentheses.</li></ol></li></ol><details open=""><summary style="font-weight:600;font-size:1.25em;line-height:1.3;margin:0">Example</summary><div class="indented"><div id="49c9cba0-016b-476b-9fef-8a361a5f92ed" class="column-list"><div id="d28981f2-89ad-472a-9ece-04a2e549b43c" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="5a404ff2-1ecc-48fc-9e1a-be82a496b1ee" class="code"><code class="language-Plain Text">Input: ( ) }</code></pre><p id="c19b45b2-6b1e-4598-91e5-9f3f405ade66" class="">
</p></div><div id="adb993da-091f-43b1-9fde-b32428d7e01d" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="685bb0f4-16dc-420a-b649-c7473aff87e9" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> top[< empty >];</pre></code></pre></div></div><div id="5fde134b-ddde-43a1-9eb6-d277cc17961b" class="column-list"><div id="8a76f6cd-5f44-4b88-919f-a13b3d364af0" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="8853b6d4-c0a1-4e53-a4b6-ba5113bbc34b" class="code"><code class="language-Plain Text">Input: ( ) }</code></pre><p id="d7ff4499-01ab-4117-930b-f04501205382" class="">The first charter in the string is <code>(</code></p><p id="d41bf1cd-9d37-4146-aa85-525239c19f61" class="">This is an open bracket so we push the character to the top of the stack which is currently empty</p></div><div id="cb8f642c-0517-4155-8869-13fa6f57f7c1" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="3e2172ee-e298-43d3-916a-1ab42823f7e5" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --- top["("];</pre></code></pre></div></div><div id="996804c7-a9e8-4498-a4fe-d646b55f6127" class="column-list"><div id="6c1a5302-ff46-49c8-9196-7a096f7f1c4f" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="d3991b36-9168-40d6-8f8d-48ae308d99eb" class="code"><code class="language-Plain Text">Input: ( ) }</code></pre><p id="f5833f7b-8d94-49e5-be04-faaa9327331f" class="">The second character in the string is <code>)</code></p><p id="8d30261f-1e1a-4bdc-bb89-f4666324dbcd" class="">This is a closing bracket. We pop the character from the top of the stack; which is the open bracket <code>(</code></p></div><div id="3f540d7d-e9d9-463a-8b02-7125c65a4195" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="bb246941-6350-4259-b432-d9da3d9904f6" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> top[< empty >];</pre></code></pre></div></div><div id="1b8ee5ec-5da5-45b0-b6a8-9fbf7482152d" class="column-list"><div id="35d2846f-84ae-41d3-b363-767d3af63da3" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="38b9b94a-ae9e-439a-a9b4-d3b9405e3039" class="code"><code class="language-Plain Text">Input: ( ) }</code></pre><p id="b6783811-7729-4c55-a377-ab85a00da5ea" class="">The third character in the string is <code>}</code></p><p id="300e7bbd-cbc8-427d-b5dc-aa350665070e" class="">This is a closing bracket, so we have to pop from the top of the stack.</p><p id="149f5e1d-63fa-4c69-863d-a16f18d90033" class="">The problem is that the top of the stack is empty, so there is no corresponding open bracket for this closing bracket. Therefore this string is not valid.</p></div><div id="31e39f2d-4ea1-4e21-8b54-37561aa68d22" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="a405cda6-1e01-455f-8ac3-b26450a9cb89" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> top[< empty >];</pre></code></pre></div></div></div></details></li></ol><ol type="i" id="28c066c8-5934-4790-a52d-24cf966be2d1" class="numbered-list" start="2"><li>Check if the open bracket that is popped from the stack is the same type as the closing bracket character<ol type="1" id="88a26b8b-42fb-408f-b681-27d03d8e4bf7" class="numbered-list" start="1"><li>If they are matching, then we continue iterating through the string</li></ol><ol type="1" id="f068512c-70b5-4fd1-aa14-bc69de3f3c4f" class="numbered-list" start="2"><li>if they are not matching, then we return <code>False</code> immediately as the string does not have valid parentheses</li></ol></li></ol></li></ol></li></ol><ol type="1" id="9ffb48a0-0058-4c53-a092-c907518a44bc" class="numbered-list" start="3"><li>Upon completion of iterating the string, we have now validated:<ol type="a" id="75833f50-c5db-482a-bc63-86c8d1d37700" class="numbered-list" start="1"><li>For each closing bracket in the string, there is a corresponding open bracket of the same type in the correct order<ol type="i" id="495bcf87-6583-4b8c-90b9-42c9acf7586b" class="numbered-list" start="1"><li>However, we have not validated that for each open bracket there is a corresponding closing bracket in the string in the correct order and the correct type</li></ol></li></ol><ol type="a" id="75f7a287-6005-4992-a5d4-208a04896d22" class="numbered-list" start="2"><li>Therefore, the last validation we need to do validate that the stack is empty<ol type="i" id="43eea819-4753-4b74-8c42-20a7ba96aa74" class="numbered-list" start="1"><li>This means that for each open bracket there is a corresponding closing bracket in the correct order of the same type</li></ol></li></ol><details open=""><summary style="font-weight:600;font-size:1.25em;line-height:1.3;margin:0">Example</summary><div class="indented"><div id="bcb16854-62f0-4aec-aacb-fceed7502420" class="column-list"><div id="5704e9a6-6be7-4dce-b520-647b23fbb2d2" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="c816c8c8-1ae4-4f4f-9c05-b5d067482656" class="code"><code class="language-Plain Text">Input: ( { }</code></pre></div><div id="a54b0652-cd43-4540-9f5b-409723815f0a" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="29d86b7f-1033-4dd8-ab43-ae003ead513b" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> top[< empty >];</pre></code></pre></div></div><div id="0720b171-35f4-4471-b601-479d752af5ca" class="column-list"><div id="b41f9852-dcf6-4dc1-852c-fd21df61eaba" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="1c19e4fe-a710-4567-91e8-d37476f0ce2f" class="code"><code class="language-Plain Text">Input: ( { }</code></pre><p id="1cf9ccd0-9f19-498a-85d1-78aff2ef1557" class="">The first charter in the string is <code>(</code></p><p id="ea92dd80-a281-4e02-8510-1783b5ff8343" class="">This is an open bracket so we push the character to the top of the stack which is currently empty</p></div><div id="a81e06b1-9bd8-4456-ac0c-3ec5802cd572" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="28f910fb-edf8-40ac-a1d5-631d3950284f" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> parenthesis1["("];</pre></code></pre></div></div><div id="d50a075a-b54a-4f7d-a70c-2cf9f124fee8" class="column-list"><div id="341047cf-4490-4c14-a932-4fb395a76cf1" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="d2140ccc-37e7-48a8-af36-427e808a59ca" class="code"><code class="language-Plain Text">Input: ( { }</code></pre><p id="b002983e-6d8a-4f84-a0ec-d9d15199a96a" class="">The first charter in the string is <code>(</code></p><p id="bf848bf4-ea5c-4df6-97e0-87ff1f4bce49" class="">This is an open bracket so we push the character to the top of the stack. <code>{</code> is now above <code>(</code> in the stack.</p></div><div id="e985dac4-ac00-435c-b079-812fd227d4f1" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="31a69da3-8490-4c78-8f2c-253a2d0dbd8a" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> parenthesis1["("];
	parenthesis1 --> brace1["{"];</pre></code></pre></div></div><div id="79a09c21-061c-48e9-a88e-5c56c559367d" class="column-list"><div id="bc12b219-852d-44f7-816b-689c6e318b63" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="ab9f6644-1e2c-4c5c-a65c-d35245c34147" class="code"><code class="language-Plain Text">Input: ( { }</code></pre><p id="005791d7-e3f9-48db-81e4-ddd946418b29" class="">The third character in the string is <code>}</code></p><p id="3e635e1d-1c8f-4f99-a7d3-556d50d5fe71" class="">This is a closing bracket, so we have to pop from the top of the stack which will be <code>{</code></p><p id="d8f0ce51-2b8a-423c-b035-acc3dfd4d5ef" class="">That is the corresponding open bracket for the closing bracket <code>}</code>. This is the same type of bracket and is in the correct order, so we continue iterating through the string.</p></div><div id="fe44a013-185f-46e5-805c-97f818522778" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="16314fea-f7f3-44d6-bf30-9941f17732b2" class="code"><code class="language-Mermaid"><pre class="mermaid">graph BT
  stack[bottom of stack] --> parenthesis1["("];</pre></code></pre></div></div><p id="d9616cc5-dc9b-4920-8553-ac87c2309ae7" class="">We successfully iterated the string and have validated that the closing bracket we encountered in the string <code>}</code> had a corresponding open bracket of the same type in the correct order.</p><p id="e70e2970-2081-400e-be8d-598f11d9420a" class="">However the stack is not empty because we have an open bracket <code>(</code> where we did not encounter a corresponding closing bracket <code>)</code> is the correct order (which should be after the closing bracket <code>}</code>).</p><p id="4ad75514-326c-4e81-b63f-adace771c347" class="">Therefore, this is not a valid parentheses string</p></div></details></li></ol><hr id="f290381b-4b25-4690-8864-ccea2c77130b"/><h3 id="d379a394-4668-45f8-8caa-e6fdeb33c95c" class="">Implement</h3><h3 id="4609be03-0e2a-4727-b868-4a9ce5c44f8d" class="">Base Code</h3><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="a24dfa3a-1044-4ed7-95ff-434a218536b7" class="code"><code class="language-Plain Text">class Solution:
	def isValid(self, s: str) -&gt; bool:</code></pre><div id="c3d46d48-7a4b-4f7e-8280-ef470f637868" class="column-list"><div id="cc37ce70-107b-4ca4-9b84-7a39b9bb03bf" style="width:100%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="9a189aab-7c13-40e2-943f-83446aaaaebc" class="code"><code class="language-Python">class Solution:
	def __init__(self) -&gt; None:
		self._stack = []
  ...</code></pre></div><div id="4c1e059e-18a3-4e85-b331-bb4922916753" style="width:100%" class="column"><p id="59783fe1-5f86-4d19-b7d7-dc698cf3eb18" class="">We implement Step <code>1</code> to iterate each character in the string.</p><p id="86edea55-2ce8-4cab-bebf-10133b552a01" class="">Instantiate an empty stack.</p><p id="5b3d3bf3-ada7-4321-af4a-15099f8d89bb" class="">In python, that can be an array.</p><ul id="9008f033-5b64-49e9-938f-7d7466aaa2ae" class="bulleted-list"><li style="list-style-type:disc"><code>.pop()</code>: Pop from top of the stack</li></ul><ul id="6f2655a6-4872-415a-a8ec-91c5051c4dc5" class="bulleted-list"><li style="list-style-type:disc"><code>.append()</code>: Push to top of the stack</li></ul><p id="1a034d2f-d283-46b7-8a8d-1bc9d427f044" class="">
</p></div></div><div id="85325e4f-f071-438a-9d77-e56b299925e1" class="column-list"><div id="1f224296-a5d0-48b9-801b-c670de0e5f44" style="width:100.00000000000003%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="7595eb9c-a86a-4622-a554-992942a7a3ac" class="code"><code class="language-Python">class Solution:
  ...
	def isValid(self, s: str) -&gt; bool:
		if not s:
			return True</code></pre></div><div id="d24f840d-254a-4664-bfbc-31b0e3ffa0ac" style="width:200.00000000000009%" class="column"><p id="f8f907f1-6a45-4daa-bd0f-f3f2bdc9df12" class="">Catch the edge case that <code>s</code> can be an empty string.</p><p id="4a28b3f0-2c7b-4c9f-9867-3ffbe9aa3495" class="">If it’s an empty string, we return <code>True</code></p><p id="62f01791-8089-4493-8d95-82eb33996113" class="">
</p></div></div><div id="cac9d29a-3f22-48b4-807b-c99696436d8a" class="column-list"><div id="d3fbcb3e-c079-443f-93e5-79e91fdc5920" style="width:100.00000000000003%" class="column"><p id="12104af4-4ceb-4ee0-b4f4-f3e9ccd481c7" class="">We implement Step <code>2a</code> to iterate each character in the string.</p><p id="0af85f99-c6d2-4349-9490-bf3109746093" class="">If it’s any open bracket, we want to push the character to the top of the stack.</p><p id="a59fea44-c818-4071-ab66-939c58c9fd32" class="">To check if the character (<code>char</code>) is an open bracket, we check if that character is in the list of open brackets <code>[&#x27;{&#x27;, &#x27;[&#x27;,&#x27; &#x27;(&#x27;]</code></p></div><div id="06ab384b-6322-4e43-8d9f-1204e57b0166" style="width:200.00000000000009%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="14a60ffe-b908-4c1a-a025-856845f8a504" class="code"><code class="language-Python">class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    for char in s:
      if char in [&#x27;{&#x27;, &#x27;[&#x27;,&#x27; &#x27;(&#x27;]:
        self._stack.append(char)</code></pre></div></div><div id="d50a5056-b5c2-41ae-b9ce-43fac07ad3a1" class="column-list"><div id="0f44a341-1510-4e35-bccc-6cf9fe079e0d" style="width:100.00000000000003%" class="column"><p id="b1e7708c-1700-4932-9ce3-34ca6cae8cb7" class="">(optional) - Refactor to be readable</p><p id="48a68696-09e9-42a9-815e-bc29cdf42fa2" class="">This step is not required but can make this more readable by refactoring the list of open brackets to a global variable called  <code>_OPEN_BRACKETS</code> </p><p id="16c0a652-9ca8-499f-8718-bd41356055fe" class="">Also changed to a <code>set</code> to optimize check if character is open bracket to O(1)</p><p id="f177ad11-22d8-444f-a74e-06286ba40997" class="">
</p></div><div id="65f89808-f98e-40a2-9c90-65ababb2775f" style="width:200.00000000000009%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="aac0d478-bc6f-4180-8e5a-821c2ac5076d" class="code"><code class="language-Python">_OPEN_BRACKETS = set([&#x27;[&#x27;, &#x27;{&#x27;, &#x27;(&#x27;])

class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    for char in s:
      if char in _OPEN_BRACKETS:
        self._stack.append(char)</code></pre></div></div><div id="2cbed1dc-6a16-4711-86d8-d56dab543a7b" class="column-list"><div id="61087e27-bacf-427c-bb26-77de78b553e5" style="width:100.00000000000003%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="56a20240-e0b5-4bbc-8726-b33433c6582e" class="code"><code class="language-Python">_OPEN_BRACKETS = set([&#x27;[&#x27;, &#x27;{&#x27;, &#x27;(&#x27;])

class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    for char in s:
      ...
			else:
        open_bracket = self._stack.pop()</code></pre></div><div id="d005eb43-2a9a-4cdc-add3-fb4e5d3ffa0c" style="width:200.00000000000009%" class="column"><p id="816c1673-6131-4480-83f1-0267ac1bd448" class="">We implement Step <code>2bi</code> to pop from the top of the stack if we see a closing bracket.</p><p id="01c7547b-6b1a-4743-8627-3dd718da8c91" class="">This can be caught in the <code>else</code> condition as the <code>if</code> condition check if the character is an open bracket.</p><p id="7a58bb75-6435-4159-81c2-482b456943f8" class="">If <code>char in _OPEN_BRACKETS</code> returns <code>False</code> in the if condition, that means that the current character must be a closing bracket.</p></div></div><div id="f9af6fb6-1fcd-42d8-83e8-66208bce86a0" class="column-list"><div id="67e60d31-88a5-4299-9a69-f7dac2807374" style="width:100.00000000000003%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="fc4d5688-6e82-4ec1-8ba2-28101df9cc8d" class="code"><code class="language-Python">_OPEN_BRACKETS = set([&#x27;[&#x27;, &#x27;{&#x27;, &#x27;(&#x27;])

class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    for char in s:
      ...
			else:
        open_bracket = self._stack.pop()
				try:
          open_bracket = self._stack.pop()
        except IndexError:
					# No corresponding open bracket in stack
          return False</code></pre></div><div id="b88a6a54-8cd7-4f8b-a511-a1c335695430" style="width:200.00000000000009%" class="column"><p id="0be56450-1e9e-4777-b4d5-4e8ccf09c6a6" class="">We implement Step <code>2bi1</code> to check that there is item to pop from the top of the stack.</p><p id="3cb14979-6108-43d7-bcba-61cc5ebe411e" class="">If we try to pop from an empty stack, it means that there is no corresponding open bracket so the string is not valid parentheses. Thus, we return <code>False</code></p><p id="97c70f65-fef9-4917-92f1-01c431b1ac69" class="">We can check if the step is empty by wrapping the <code>.pop()</code> in a <code>try ... except IndexError</code></p><p id="2d1d07dd-33dd-4b96-bea1-041f9b8e85e7" class="">
</p></div></div><div id="c2b90854-a656-4a3c-ab56-de993d31ead4" class="column-list"><div id="f7e3a256-4fcf-4730-98da-def092721a01" style="width:100.00000000000003%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="5b5a843c-3c1c-4a5e-9071-c249438c7d1c" class="code"><code class="language-Python">_CLOSE_BRACKET_TO_OPEN_BRACKET = {
  &#x27;]&#x27;: &#x27;[&#x27;,
  &#x27;}&#x27;: &#x27;{&#x27;,
  &#x27;)&#x27;: &#x27;(&#x27;,
}

class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    for char in s:
      ...
			else:
        ...
				if open_bracket != _CLOSE_BRACKET_TO_OPEN_BRACKET.get(char):
					return False</code></pre></div><div id="45fc02d6-776d-4c10-a156-0b5d3896f261" style="width:200.00000000000009%" class="column"><p id="b9e7d20e-c558-43de-a7eb-74d179cf0e72" class="">We implement Step <code>2bii</code> to check that the open bracket popped from the top of the stack that corresponds to the current closing bracket character is of the same type.</p><p id="8f6d7b8c-6576-4cb1-b2d1-02bc928ed55d" class="">We can do this by creating a mapping <code>_CLOSE_BRACKET_TO_OPEN_BRACKET</code>of closing bracket to the same type for open bracket.</p><p id="38eb3905-00d9-42ad-88d9-7c7670eba766" class="">If they are of the same type, we continue iterating. Otherwise, we return <code>False</code>.</p></div></div><div id="2b69eeff-499d-4416-bffe-12b991495bf7" class="column-list"><div id="0a3da508-f5a2-40d5-9510-e82875906218" style="width:100.00000000000003%" class="column"><p id="28535b01-b656-446a-a59e-5edc791cde0a" class="">We implement Step <code>3b</code> to validate that the stack is empty.</p><p id="76ecc62b-11fe-4c58-90f9-a691810844bb" class="">If the stack is empty, that means that all opening brackets have a corresponding closing bracket in the correct order of the same type in the string.</p><p id="0136283c-87bc-46c5-877c-d55bfa156273" class="">if self._stack is an empty array, then <code><em>not</em></code><code> </code><code><em>self</em></code><code>._stack</code> will return <code>True</code></p></div><div id="a7c64c12-0437-4d6d-81e5-0298bd467dfd" style="width:200.00000000000009%" class="column"><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="984bdf25-6598-4a39-88d8-babb34f683bc" class="code"><code class="language-Python">class Solution:
	...
  def isValid(self, s: str) -&gt; bool:
    ...
    return not self._stack</code></pre><p id="b05aad44-b445-47b4-b50d-e465f9f88c6d" class="">
</p></div></div><hr id="9591620a-1cb1-4597-bc53-9c51b7da9d29"/><h3 id="eff50125-ccd5-41a1-b05d-a1fd0466fa96" class="">Final Code</h3><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="71f78011-bc3b-4ae6-98d5-55523661cfbb" class="code"><code class="language-Python">_OPEN_BRACKETS = set([&#x27;[&#x27;, &#x27;{&#x27;, &#x27;(&#x27;])
_CLOSE_BRACKET_TO_OPEN_BRACKET = {
    &#x27;]&#x27;: &#x27;[&#x27;,
    &#x27;}&#x27;: &#x27;{&#x27;,
    &#x27;)&#x27;: &#x27;(&#x27;,
}

class Solution:
    def __init__(self) -&gt; None:
        self._stack = []

    def isValid(self, s: str) -&gt; bool:
        if not s:
            return True
        for char in s:
            if char in _OPEN_BRACKETS:
                self._stack.append(char)
            else:
                try:
                    open_bracket = self._stack.pop()
                except IndexError:
                    # No corresponding open bracket in stack
                    return False
                if open_bracket != _CLOSE_BRACKET_TO_OPEN_BRACKET.get(char):
                    return False
        return not self._stack</code></pre><p id="8ca77249-d683-4a94-b500-27fb819a3734" class="">
</p><figure class="block-color-red_background callout" style="white-space:pre-wrap;display:flex" id="0d089150-d9ab-419d-9475-eade5bb24e2e"><div style="font-size:1.5em"><span class="icon">💡</span></div><div style="width:100%">Once comfortable with implementation of the problem, it is good practice to verify your implementation would work if given an input by<br/>1. Statically analyze the code to catch any obvious code<br/>2. Walk through the code given an input and validate output is expected<br/>3. Discuss the runtime and space complexity of the solution<br/></div></figure><h3 id="f943e334-e43d-4cb2-a1b2-683d1c53c806" class="">Walkthrough Code</h3><p id="6bdd2926-064d-4efb-a5bb-a148c0b6f2c8" class="">Walk through the code with a valid input and verify the variable state</p><ul id="62b47363-eae3-43dc-b2ad-e5c22adb52ed" class="bulleted-list"><li style="list-style-type:disc">State what value each variable will have</li></ul><ul id="bf8aec86-3662-4e21-9b67-4b47ecd5b8cc" class="bulleted-list"><li style="list-style-type:disc">For loops:<ul id="cf745feb-1c43-40bb-a5bc-b77bc3901738" class="bulleted-list"><li style="list-style-type:circle">Update the state of variables inside the loop based on current iteration</li></ul></li></ul><ul id="46510289-624c-4aec-8c2d-986a690d6a81" class="bulleted-list"><li style="list-style-type:disc">Validate return value matches what is expected</li></ul><h3 id="0ba7d17f-f3a0-4d7e-8e8d-ed1b1e849cb7" class="">Complexity</h3><p id="ad043920-ab50-4b06-8b46-832c7fe1d500" class="">There are two types of complexity we will discuss</p><ol type="1" id="ef294a5f-561d-4365-8295-adcc11226b63" class="numbered-list" start="1"><li>Runtime complexity - average performance of application (given in big-O notation)</li></ol><ol type="1" id="710390ec-1e35-43a1-813a-c713083ac3c2" class="numbered-list" start="2"><li>Space complexity - average memory usage of application (given in big-O notation)</li></ol><h3 id="ce3c4585-2663-4769-827d-add874d91024" class="">Runtime Complexity</h3><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="2ac35911-c37a-4728-9459-8000c9439235" class="code"><code class="language-Python">def isValid(self, s: str) -&gt; bool:
    if not s: # O(1) constant check that s is not empty
        return True
    for char in s: # O(n) w. n is length of string as we need to iterate each character in the string
        if char in _OPEN_BRACKETS: # O(1) constant time to check char is in a hashset
            self._stack.append(char) # O(1) constant time to push char to the stack
        else:
            try:
                open_bracket = self._stack.pop() # O(1) constant time to pop char off the stack
            except IndexError:
                # No corresponding open bracket in stack
                return False
            if open_bracket != _CLOSE_BRACKET_TO_OPEN_BRACKET.get(char): # O(1) constant time to check equality and access the map
                return False
    return not self._stack # O(1) constant time to check stack is empty</code></pre><p id="d4b79e65-6076-418d-9111-f070ee6dfb67" class="">We have deduced that there are O(1) and O(n) complexity in the application.</p><p id="8b6b1818-0ea2-4542-98a8-a96fdfd62e03" class="">The biggest notation we have is O(n) which is the for loop. Everything inside the for loop is executed n time from the upper for loop. In this case, all the logic inside the for loop are of max O(1) runtime complexity. Therefore, the big-O notation for the entire for loop is <code>O(n * 1) = O(n)</code>.</p><table id="5a4c08b3-aa0e-456c-a27e-4060d55fe8cc" class="simple-table"><thead class="simple-table-header"><tr id="c8b15889-cd74-40c3-8fc4-a2e79e047e01"><th id="NXMf" class="simple-table-header-color simple-table-header" style="width:349px">Code path</th><th id="YG|J" class="simple-table-header-color simple-table-header" style="width:349px">Big-O Runtime Complexity</th></tr></thead><tbody><tr id="9575eae6-335a-4203-b174-a92110d333a3"><td id="NXMf" class="" style="width:349px">if not s:<br/>        return True<br/></td><td id="YG|J" class="" style="width:349px">O(1)</td></tr><tr id="8fbcdc99-17d7-449b-ad5e-e1989b1e18b8"><td id="NXMf" class="" style="width:349px">for char in s:<br/>        ….<br/></td><td id="YG|J" class="" style="width:349px">O(n)</td></tr><tr id="7956d5ec-f93f-474e-8064-d096d802d95b"><td id="NXMf" class="" style="width:349px">return not self._stack</td><td id="YG|J" class="" style="width:349px">O(1)</td></tr></tbody></table><p id="1204eed8-5bcb-4b18-8ceb-f91d504dc752" class="">The max of all the three top-level logic is <code>O(n)</code> which is our overall runtime complexity.</p><h3 id="611efff8-b731-4bde-9b53-67875cdf1628" class="">Space Complexity</h3><script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/prism.min.js" integrity="sha512-7Z9J3l1+EYfeaPKcGXu3MS/7T+w19WtKQY/n+xzmw4hZhJ9tyYmcUS+4QqAlzhicE5LAfMQSF3iFTK9bQdTxXg==" crossorigin="anonymous" referrerPolicy="no-referrer"></script><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.29.0/themes/prism.min.css" integrity="sha512-tN7Ec6zAFaVSG3TpNAKtk4DOHNpSwKHxxrsiw4GHKESGPs5njn/0sMCUMl2svV4wo4BK/rCP7juYz+zx+l6oeQ==" crossorigin="anonymous" referrerPolicy="no-referrer"/><pre id="3377fd9c-edd3-454e-86da-97328d5ad4b1" class="code"><code class="language-Python">_OPEN_BRACKETS = set([&#x27;[&#x27;, &#x27;{&#x27;, &#x27;(&#x27;]) # O(1) as this is a fixed size list
_CLOSE_BRACKET_TO_OPEN_BRACKET = { # O(1) as this is a fixed size map
    &#x27;]&#x27;: &#x27;[&#x27;,
    &#x27;}&#x27;: &#x27;{&#x27;,
    &#x27;)&#x27;: &#x27;(&#x27;,
}

class Solution:
    def __init__(self) -&gt; None:
        self._stack = [] # O(n) w. n can be the length of s in isValid

    def isValid(self, s: str) -&gt; bool:
        if not s:
            return True
        for char in s:
            if char in _OPEN_BRACKETS:
                self._stack.append(char)
            else:
                try:
                    open_bracket = self._stack.pop()
                except IndexError:
                    # No corresponding open bracket in stack
                    return False
                if open_bracket != _CLOSE_BRACKET_TO_OPEN_BRACKET.get(char):
                    return False
        return not self._stack</code></pre><p id="a2235bf0-5b48-4dbc-b4cb-d9039445b9df" class="">The variable that is of dynamic size that is not known is the size of the stack. String s can have an unknown number of open brackets that will need to be pushed to the stack.</p><p id="addc62e6-5f62-4262-ba0a-0730c4f9ee22" class="">If s is of length 20, the stack can have a size between <code>0 - 20</code> as s can have 0 open brackets, 20 open brackets, or a number between those two boundaries. Therefore, the space complexity of the application is <code>O(n) w. n is the length of s</code>.</p></div></article><span class="sans" style="font-size:14px;padding-top:2em"></span></body></html>
`;



// WEBPACK FOOTER //
// ./src/components/html/blog_1.js